<template>
  <layout :session="session">
    <!-- <div class="mt-12 sm:mt-6 px-8 py-5 text-left">
      <p class="text-sm mb-2">Frage {{ question.prio }} von 5</p>
      <h1 class="text-lg sm:text-question-large font-extralight">
        {{ question.question }}
      </h1>

      <div class="border-t border-gray-400 mt-4 mb-6"></div>

      <rating :session="session" :translations="translations"></rating>
    </div> -->

    <div class="mt-8 sm:mt-6 flex flex-col justify-between items-center px-4 py-5 text-left max-w-sm mx-auto">
      <div class="flex-1 px-4">
        <!-- <p class="text-sm mb-2">Frage {{ phase.order }} von {{ numPhases }}</p> -->
        <p class="mt-2 text-lg sm:text-2xl font-extralight">
          {{ generatedQuestion }}
        </p>
        <p v-if="question.sub_question" class="mt-3 text-sm sm:text-xl font-extralight">
          {{ question.sub_question }}
        </p>

        <div v-if="['radio', 'choices'].includes(question.question_type)" class="text-sm font-extralight mt-3">
          {{ question?.parameters?.choices.join(', ') }}
        </div>

        <div class="border-t border-gray-400 mt-4 mb-1"></div>

        <p v-if="question.question_type == 'choices' && isMultipleChoice" class="mt-4 text-xs font-extralight">
          Mehrere Antworten möglich
        </p>

        <p v-if="question.question_type == 'choices' && !isMultipleChoice" class="mt-4 text-xs font-extralight">
          Eine Antwort möglich
        </p>


      

      <scrollable-container v-if="question.live_results_type == 'scrollable_container'" :session="session"
        :translations="translations"></scrollable-container>

      <word-cloud v-if="question.live_results_type == 'word_cloud'" :session="session"
        :translations="translations"></word-cloud>

      <rating v-if="question.live_results_type == 'rating'" :session="session" :translations="translations"></rating>

      <pie-chart v-if="showPieChart" :session="session"
        :translations="translations"></pie-chart>

      <bar-chart v-if="showBarChart" :session="session"
        :translations="translations"></bar-chart>

      </div>
    </div>

    <template v-slot:footer>
      <a v-if="nextPhaseId" :href="route('control-panel.phase', {
        sessionUuid: session.uuid,
        phaseId: nextPhaseId,
      })
        "
        class="inline-flex justify-center w-full sm:w-min rounded-none sm:rounded-md border border-transparent px-3 py-1.5 sm:my-2 sm:px-2 sm:py-2 bg-brandpreneurship-dark-gray text-base leading-6 font-medium text-white shadow-sm hover:bg-black focus:outline-none focus:border-black focus:shadow-outline-red transition ease-in-out duration-150 sm:text-sm sm:leading-5 z-50">WEITER</a>

      <a v-if="!nextPhaseId" :href="route('control-panel.completed', { sessionUuid: session.uuid })"
        class="inline-flex justify-center w-full sm:w-min rounded-none sm:rounded-md border border-transparent px-3 py-1.5 sm:my-2 sm:px-2 sm:py-2 bg-brandpreneurship-dark-gray text-base leading-6 font-medium text-white shadow-sm hover:bg-black focus:outline-none focus:border-black focus:shadow-outline-red transition ease-in-out duration-150 sm:text-sm sm:leading-5 whitespace-nowrap">FERTIG.
        ZUR STARTSEITE.</a>
    </template>
  </layout>
</template>

<script>
import Layout from '@/Pages/ControlPanel/Shared/Layout';
import ScrollableContainer from '@/Pages/LiveResults/ScrollableContainer';
import WordCloud from '@/Pages/LiveResults/WordCloud';
import Rating from '@/Pages/LiveResults/Rating';
import PieChart from '@/Pages/LiveResults/PieChart';
import BarChart from '@/Pages/LiveResults/BarChart';

export default {
  metaInfo() {
    return {
      title: `${this.question.question}`,
    };
  },

  components: {
    Layout,
    ScrollableContainer,
    WordCloud,
    Rating,
    PieChart,
    BarChart,
  },

  props: [
    'session',
    'phase',
    'translations',
    'question',
    'nextPhaseId',
    'answeredBy',
  ],

  computed: {
    generatedQuestion() {

      if (!this.question?.brandname && !this.session.brandname && this.question?.question_default) {
        return this.question?.question_default;
      }

      if (this.question?.is_placeholder_question && (this.question?.brandname || this.session.brandname)) {
        return this.question.question.replace('%BRANDNAME', this.question?.brandname || this.session.brandname);
      }

      return this.question.question;
    },

    numPhases() {
      return this.session.phases.length;
    },

    isMultipleChoice() {
      const ma = this.question.parameters.options.multiple_answers;
      return ma === true || ma === 1 || ma === '1';
    },

    showBarChart() {
      if (this.question.question_type === 'choices') {
        return this.isMultipleChoice;
      }

      return this.question.live_results_type == 'barchart';
    },

    showPieChart() {
      if (this.question.question_type === 'choices') {
        return !this.isMultipleChoice;
      }

      return this.question.live_results_type == 'piechart';
    },
  },
};
</script>
